import type { ShowIf } from '../types/schema';

export function evaluateShowIf(showIf: ShowIf | undefined, formValues: Record<string, unknown>): boolean {
  if (!showIf) {
    return true;
  }

  if (showIf.op === 'and') {
    return showIf.conditions?.length === 0
      ? false
      : showIf.conditions?.every((condition) => evaluateShowIf(condition, formValues)) ?? false;
  }

  const fieldVal = showIf.field ? formValues[showIf.field] : undefined;
  switch (showIf.op) {
    case 'eq':
      return fieldVal === showIf.value;
    case 'neq':
      return fieldVal !== showIf.value;
    case 'in':
      return Array.isArray(showIf.value) && showIf.value.includes(fieldVal as string);
    default:
      return true;
  }
}